import { usePartner } from 'components/app/routes/usePartner';

import { SALES_CHANNELS } from 'config/app-config';

export const useSalesChannel = () => {
  const { partnerName } = usePartner();
  const salesChannel = SALES_CHANNELS[partnerName];

  return salesChannel ? { salesChannel } : {};
};
